/**
 * UK VAT line-item calculations (mirrors backend/utils/taxCalculations.js).
 */

export function round2(value) {
  return Math.round(value * 100) / 100;
}

export function calculateLineItemTotals({
  quantity = 1,
  unitPrice = 0,
  taxPercentage = 0,
  priceIncludesTax = false
}) {
  const qty = Number(quantity) || 0;
  const price = Number(unitPrice) || 0;
  const taxPct = Number(taxPercentage) || 0;
  const inclusive = Boolean(priceIncludesTax) && taxPct > 0;

  if (inclusive) {
    const gross = round2(qty * price);
    const taxAmount = round2((gross * taxPct) / (100 + taxPct));
    const subtotal = round2(gross - taxAmount);
    return { subtotal, taxAmount, total: gross };
  }

  const subtotal = round2(qty * price);
  const taxAmount = round2((subtotal * taxPct) / 100);
  const total = round2(subtotal + taxAmount);
  return { subtotal, taxAmount, total };
}

export function getLineItemTotal(item) {
  return calculateLineItemTotals({
    quantity: item.quantity,
    unitPrice: item.unitPrice,
    taxPercentage: item.taxPercentage,
    priceIncludesTax: item.priceIncludesTax
  }).total;
}

/** Per-unit price including VAT for display. */
export function getUnitPriceWithTax(item) {
  const unitPrice = Number(item.unitPrice) || 0;
  const taxPct = Number(item.taxPercentage) || 0;
  if (taxPct <= 0) return unitPrice;
  if (item.priceIncludesTax) return unitPrice;
  return round2(unitPrice * (1 + taxPct / 100));
}
